// Artículos de Aprender (2026-10-18): pensados para lo que la gente busca en Google y que lleva a XIMA.

export const ARTICULOS_GUIDES = [
  {
    slug: "articulos/juegos-de-mesa-cubanos",
    theme: "estrategia",
    nav: "Juegos de mesa cubanos",
    title: "Juegos de mesa cubanos: XIMA, el que se juega hacia arriba",
    description:
      "En Cuba se juega dominó, damas, parchís y ajedrez… y también XIMA, un juego de mesa de estrategia en 3D creado en La Habana en 2010. Te contamos cómo es.",
    h1: "Juegos de mesa cubanos",
    intro:
      "En Cuba los juegos de mesa son parte de la vida de barrio: el dominó en la esquina, las damas en el portal, el parchís en familia y el ajedrez, que tiene en Capablanca a uno de sus grandes campeones. En 2010 se sumó uno nuevo, nacido en La Habana: XIMA.",
    sections: [
      {
        h: "Los clásicos de siempre",
        p: [
          "El dominó es probablemente el juego de mesa más jugado en Cuba, casi siempre en parejas y con mucha conversación alrededor. El ajedrez tiene un lugar especial gracias a José Raúl Capablanca, campeón del mundo, y a una gran tradición de clubes y escuelas. Y el parchís y las damas no faltan en ninguna casa.",
          "Todos ellos tienen algo en común: se juegan sobre una mesa plana. XIMA nació precisamente para romper con eso.",
        ],
      },
      {
        h: "XIMA, un juego de mesa cubano en 3D",
        p: [
          "XIMA lo crearon en La Habana Yosdel Vicente Muiño Acevedo y Liz Power Suárez. Su tablero es una pirámide escalonada de cuatro pisos y gana quien lleve primero su bloque especial a la cima. Para subir de piso hay que apoyarse en otros bloques, así que cada partida es una carrera por construir caminos hacia arriba.",
          "Sus autores no ocultan sus raíces: la apertura más equilibrada se llama Capablanca, otra se llama Párragueña por el pueblo natal de Yosdel, y el libro del juego reconoce un aire de familia con el parchís (llegar al centro), las damas (pasar por encima de otras fichas) y el ajedrez (la notación de las jugadas).",
        ],
        figure: "tablero-vista-lateral",
      },
      {
        h: "Con dados o sin dados, como en casa",
        p: [
          "Igual que en una casa cubana se pasa del parchís al ajedrez según quién se siente a la mesa, XIMA se puede jugar con dados (Modo Azar), sin dados (Modo Ciencia) o eligiendo en cada turno (Modo Cienzar). Así sirve tanto para una tarde en familia como para una partida seria.",
        ],
      },
      {
        h: "Dónde jugarlo",
        p: [
          "XIMA se juega gratis en juegoxima.com, desde el ordenador o el móvil, contra personas de cualquier país o contra el bot. También puedes retar a tus amigos con su código de jugador y enseñarles a jugar en pocos minutos.",
        ],
      },
    ],
    faqs: [
      ["¿Cuál es el juego de mesa más popular en Cuba?", "El dominó es el más extendido, seguido del ajedrez, las damas y el parchís."],
      ["¿XIMA es un juego cubano?", "Sí. Se creó en La Habana en 2010."],
      ["¿Se puede jugar XIMA online?", "Sí, gratis en juegoxima.com, en el navegador o en el móvil."],
    ],
    related: ["historia-de-xima", "que-es-xima", "articulos/xima-y-el-ajedrez", "como-jugar"],
    cta: { label: "Qué es XIMA", slug: "que-es-xima" },
  },
  {
    slug: "articulos/juegos-de-estrategia-para-ninos",
    theme: "estrategia",
    nav: "Juegos de estrategia para niños",
    title: "Juegos de estrategia para niños: cómo enseñar XIMA",
    description:
      "Por qué los juegos de estrategia ayudan a los niños a pensar y cómo enseñarles XIMA paso a paso: reglas sencillas, Modo Azar para empezar y partidas cortas.",
    h1: "Juegos de estrategia para niños",
    intro:
      "Los juegos de estrategia enseñan a pensar antes de actuar, a planificar y a aceptar una derrota. XIMA es una buena opción para niños porque todas sus piezas se mueven igual: las reglas se aprenden en minutos.",
    sections: [
      {
        h: "Qué aprenden los niños jugando",
        list: [
          "A pensar varias jugadas por delante: «si pongo aquí este bloque, ¿qué hará el otro?».",
          "A tener un objetivo y un plan para llegar a él.",
          "A concentrarse y a esperar su turno.",
          "A aprender de sus errores: repasar la partida y ver dónde se equivocaron.",
          "Y, en XIMA, algo más: a ganar construyendo un camino, no destruyendo al rival.",
        ],
      },
      {
        h: "Por qué XIMA es fácil para empezar",
        p: [
          "En muchos juegos de estrategia hay que memorizar cómo se mueve cada pieza. En XIMA no: todos los bloques avanzan en línea recta, en cualquier dirección. Solo hay que fijarse en una idea: para subir de piso hace falta apoyarse en otro bloque, como en una escalera.",
          "Además, el tablero en forma de pirámide se entiende a simple vista: el objetivo está arriba del todo.",
        ],
        figure: "subir-con-escalon",
      },
      {
        h: "Cómo enseñarlo en cuatro partidas",
        list: [
          "Primera partida: juega en Modo Azar. Los dados dicen cuántos pasos mover y el niño solo decide qué bloque mueve. Es divertido y quita presión.",
          "Segunda partida: explícale el escalón. Pon un bloque pegado al segundo piso y enséñale a subir otro por encima.",
          "Tercera partida: enséñale a dominar (ponerse encima de un bloque rival para dejarlo quieto).",
          "Cuarta partida: prueba el Modo Ciencia, sin dados, para que cada decisión sea suya.",
        ],
      },
      {
        h: "Consejos para padres y profesores",
        list: [
          "Partidas cortas: es mejor jugar tres partidas de 15 minutos que una de una hora.",
          "Deja que gane a veces, sobre todo al principio.",
          "Pregunta en vez de corregir: «¿por qué has movido ahí?».",
          "Contra el bot en dificultad Fácil pueden practicar solos.",
          "Los puzzles diarios son retos cortos ideales para niños.",
        ],
      },
    ],
    faqs: [
      ["¿A partir de qué edad se puede jugar XIMA?", "Las reglas son sencillas y los más pequeños pueden jugar en Modo Azar con ayuda de un adulto; el Modo Ciencia es mejor a partir de la edad en que ya disfrutan juegos como las damas o el ajedrez."],
      ["¿XIMA es gratis?", "Sí, se juega gratis en juegoxima.com."],
    ],
    related: ["como-jugar", "azar", "puzzles", "bots"],
    cta: { label: "Cómo jugar", slug: "como-jugar" },
  },
  {
    slug: "articulos/alternativas-al-ajedrez",
    theme: "estrategia",
    nav: "Juegos parecidos al ajedrez",
    title: "Juegos parecidos al ajedrez: 5 alternativas para probar",
    description:
      "Si te gusta el ajedrez, prueba estos juegos de estrategia: las damas, el go, el shogi, el xiangqi y XIMA, el juego de mesa en 3D que puedes jugar gratis online.",
    h1: "Juegos parecidos al ajedrez",
    intro:
      "El ajedrez es el rey de los juegos de estrategia, pero no es el único. Si te gusta pensar jugadas por adelantado, estos juegos te van a gustar.",
    sections: [
      {
        h: "1. Las damas",
        p: [
          "Se juegan en el mismo tipo de tablero que el ajedrez, pero todas las piezas son iguales y se captura saltando por encima. Son fáciles de aprender y muy profundas en su variante internacional, de 10 × 10 casillas.",
        ],
      },
      {
        h: "2. El go",
        p: [
          "Nacido en China hace miles de años, se juega colocando piedras en las intersecciones de una cuadrícula para rodear territorio. Tiene muy pocas reglas y una profundidad enorme.",
        ],
      },
      {
        h: "3. El shogi",
        p: [
          "Es el «ajedrez japonés». Su gran particularidad es que las piezas que capturas pasan a tu ejército y puedes volver a ponerlas en el tablero, lo que hace las partidas muy dinámicas.",
        ],
      },
      {
        h: "4. El xiangqi",
        p: [
          "El «ajedrez chino» se juega sobre las intersecciones del tablero, con un río en el medio y un palacio del que el general no puede salir. Es uno de los juegos más jugados del mundo.",
        ],
      },
      {
        h: "5. XIMA: el ajedrez hacia arriba",
        p: [
          "XIMA es un juego cubano creado en 2010 con el ajedrez muy presente: tiene notación algebraica, aperturas con nombre (una se llama Capablanca) y una teoría de finales. Pero cambia lo esencial: el tablero es una pirámide de cuatro pisos, todos los bloques se mueven igual y gana quien lleve su bloque especial a la cima.",
          "La gran novedad es la altura: para subir de piso hay que apoyarse en otro bloque, así que no basta con controlar casillas, hay que construir caminos. Y nunca hay tablas: si la partida se atasca, cada jugador recibe material extra. Se puede jugar gratis online contra personas o contra el bot.",
        ],
        figure: "tablero-vista-superior",
      },
      {
        h: "¿Cuál elegir?",
        table: {
          head: ["Juego", "Lo mejor", "Dificultad de reglas"],
          rows: [
            ["Damas", "Rápido y familiar", "Muy fácil"],
            ["Go", "Profundidad con pocas reglas", "Fácil"],
            ["Shogi", "Piezas que vuelven al juego", "Media"],
            ["Xiangqi", "Muy popular en Asia", "Media"],
            ["XIMA", "Tablero 3D y sin tablas", "Fácil"],
          ],
        },
      },
    ],
    faqs: [
      ["¿Qué juego se parece más al ajedrez?", "El shogi y el xiangqi son sus parientes más cercanos. XIMA comparte con el ajedrez la notación, las aperturas y los finales, pero en un tablero 3D."],
      ["¿Dónde puedo jugar XIMA?", "Gratis en juegoxima.com, en el navegador o el móvil."],
    ],
    related: ["articulos/xima-y-el-ajedrez", "que-es-xima", "estrategia/aperturas-xima", "como-jugar"],
    cta: { label: "XIMA y el ajedrez", slug: "articulos/xima-y-el-ajedrez" },
  },
  {
    slug: "articulos/juegos-de-mesa-en-familia",
    theme: "estrategia",
    nav: "Juegos de mesa en familia",
    title: "Juegos de mesa para jugar en familia: por qué probar XIMA",
    description:
      "Ideas para jugar en familia con XIMA: de 2 a 4 jugadores, por parejas, con dados para que todos tengan opciones y partidas que se aprenden en pocos minutos.",
    h1: "Juegos de mesa en familia",
    intro:
      "XIMA nació con una idea muy concreta: un juego que permitiera pasar más tiempo juntos en casa. Por eso se puede jugar de muchas formas, desde una partida tranquila entre dos hasta una de cuatro con dados.",
    sections: [
      {
        h: "Por qué funciona en familia",
        list: [
          "Se aprende en pocos minutos: todos los bloques se mueven igual.",
          "Se juega de 2 a 4 personas.",
          "Con el Modo Azar los dados igualan las fuerzas, así que los peques pueden ganar a los mayores.",
          "No hay eliminación: aunque te capturen el bloque especial, puedes rescatarlo y seguir.",
          "Nunca termina en empate.",
        ],
      },
      {
        h: "Formas de jugar",
        defs: [
          ["Uno contra uno", "La forma clásica, ideal para dos hermanos o padre e hijo."],
          ["Todos contra todos", "Hasta cuatro jugadores, cada uno con su color."],
          ["Por parejas", "El libro de XIMA contempla el juego por equipos; en la notación, «0-1-0-1» indica que ganaron el segundo y el cuarto jugador."],
          ["Contra uno mismo", "El libro recomienda el Modo Cienzar para jugar en solitario, porque no sabes qué saldrá en los dados del otro bando."],
        ],
      },
      {
        h: "Ideas para una tarde de juego",
        list: [
          "Empezad con una partida de Modo Azar para que todos se diviertan.",
          "Después, una partida de Modo Ciencia entre los que quieran pensar más.",
          "Terminad resolviendo juntos el puzzle del día.",
          "Si estáis lejos, jugad online: cada uno desde su casa, en la misma partida.",
        ],
      },
    ],
    faqs: [
      ["¿Cuántas personas pueden jugar a XIMA?", "De 2 a 4."],
      ["¿Hay versión física del juego?", "Sí, el juego de mesa de XIMA aparece en la Tienda de la web."],
    ],
    related: ["azar", "cienzar", "articulos/juegos-de-estrategia-para-ninos", "amigos"],
    cta: { label: "Modo Azar", slug: "azar" },
  },
  {
    slug: "articulos/juegos-de-mesa-online-gratis",
    theme: "estrategia",
    nav: "Juegos de mesa online gratis",
    title: "Juegos de mesa online gratis: cómo jugar XIMA en el navegador",
    description:
      "XIMA es un juego de mesa online y gratis: juega en el navegador o el móvil contra personas, contra el bot en 4 niveles, en torneos, con amigos o con el puzzle del día.",
    h1: "Juegos de mesa online gratis",
    intro:
      "Puedes jugar XIMA online y gratis, sin instalar nada: abre juegoxima.com en el ordenador o en el móvil y elige cómo quieres jugar.",
    sections: [
      {
        h: "Todo lo que puedes hacer gratis",
        list: [
          "Jugar en vivo contra personas de cualquier país.",
          "Jugar contra el bot en cuatro niveles: Fácil, Medio, Difícil e Injusto.",
          "Entrar en torneos y en el Campeonato.",
          "Retar a tus amigos y pedir la revancha.",
          "Resolver un puzzle nuevo cada día.",
          "Ver partidas en directo y repeticiones.",
          "Analizar tus partidas con el bot (3 análisis nuevos al día).",
        ],
      },
      {
        h: "Cómo empezar en un minuto",
        list: [
          "Entra en juegoxima.com.",
          "Pulsa Jugar. Si te pasaron un enlace, puedes entrar como invitado.",
          "Para tu primera partida, elige Jugar con bot en Fácil y Modo Ciencia.",
          "Regístrate para guardar tus partidas, tus estadísticas y tu CIMAX.",
        ],
      },
      {
        h: "¿Y Premium?",
        p: [
          "Es opcional y cuesta 2 USD al mes: añade análisis de partidas, videos de tus partidas y puzzles sin límite. Para jugar no hace falta.",
        ],
      },
    ],
    faqs: [
      ["¿Hay que descargar algo para jugar XIMA?", "No. Se juega en el navegador. En Android también puedes usar la app."],
      ["¿Es realmente gratis?", "Sí. Jugar es gratis; Premium es solo un extra opcional."],
    ],
    related: ["partidas-online", "bots", "puzzles", "premium"],
    cta: { label: "Jugar online", slug: "partidas-online" },
  },
  {
    slug: "articulos/juegos-de-estrategia-3d",
    theme: "estrategia",
    nav: "Juegos de estrategia en 3D",
    title: "Juegos de estrategia en 3D: qué cambia al jugar en altura",
    description:
      "Qué tienen de especial los juegos de mesa de estrategia en 3D y cómo la altura cambia la forma de pensar en XIMA: pisos, escalones, bloqueos y caminos hacia la cima.",
    h1: "Juegos de estrategia en 3D",
    intro:
      "Casi todos los juegos de mesa se juegan sobre un plano. Añadir altura parece un detalle, pero lo cambia todo: además de dónde está una pieza, importa a qué altura está.",
    sections: [
      {
        h: "La tercera dimensión en XIMA",
        p: [
          "El tablero de XIMA es una pirámide escalonada de cuatro pisos. Un bloque puede subir, en cada paso, como mucho la altura de un bloque; como cada piso está dos alturas por encima del anterior, para subir hace falta un escalón: otro bloque, propio o rival, sobre el que pasar.",
          "Por eso la altura se convierte en recurso: un bloque que está encima de otro llega más lejos, y una torre bien colocada puede cortar el paso a varios bloques rivales a la vez.",
        ],
        figure: "tablero-vista-lateral",
      },
      {
        h: "Ideas que solo existen en 3D",
        defs: [
          ["Escalón", "Un bloque colocado para que otro suba de piso pasando por encima."],
          ["Doblar columna", "Poner un bloque propio encima de otro para ganar altura."],
          ["Bloqueo", "Cortar el paso entre pisos; distinto de la obstrucción, que corta el paso dentro de un mismo piso."],
          ["Dos centros", "El segundo piso (centro medio) y el tercero (centro alto): controlar uno u otro lleva a planes distintos."],
        ],
      },
      {
        h: "Por qué es un reto mental distinto",
        p: [
          "En un juego 3D hay que imaginar el tablero desde dos vistas a la vez: desde arriba, para ver las líneas, y de lado, para ver las alturas. Según el libro de XIMA, la cantidad de posiciones posibles crece muchísimo: unos 1.700 millones de combinaciones ya en el segundo movimiento.",
          "La buena noticia es que las reglas siguen siendo sencillas. Lo difícil, como en todo buen juego de estrategia, es jugar bien.",
        ],
      },
    ],
    faqs: [
      ["¿Qué juegos de mesa en 3D existen?", "Hay variantes 3D de juegos clásicos, como el ajedrez tridimensional, y juegos nacidos en 3D como XIMA, cuyo tablero es una pirámide de cuatro pisos."],
    ],
    related: ["reglas/subir-bloques", "reglas/bloqueo-y-obstruccion", "estrategia/medio-juego", "que-es-xima"],
    cta: { label: "Subir de piso", slug: "reglas/subir-bloques" },
  },
];
